import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { checkoutGridProps } from "@store/theme/common/props/checkout";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {}

export interface OrderDetailsPageContainerStyles {
    gridContainer?: GridContainerProps;
    mainGridItem?: GridItemProps;
    sideGridItemMobile?: GridItemProps;
    sideGridItemDesktop?: GridItemProps;
    loadingWrapper?: InjectableCss;
}

export const orderDetailsPageContainerStyles: OrderDetailsPageContainerStyles = {
    gridContainer: checkoutGridProps.container,
    mainGridItem: checkoutGridProps.mainColumn,
    sideGridItemMobile: checkoutGridProps.sideColumnMobile,
    sideGridItemDesktop: checkoutGridProps.sideColumnDesktop,
    loadingWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 150px;
        `,
    },
};

const styles = orderDetailsPageContainerStyles;

const OrderDetailsPageContainer: FC<Props> = ({ id }) => {
    const { value: order, isLoading } = useContext(OrderStateContext);

    if (isLoading) {
        return (
            <StyledWrapper {...styles.loadingWrapper}>
                <LoadingSpinner />
            </StyledWrapper>
        );
    }

    if (!order) {
        return null;
    }

    return (
        <GridContainer {...styles.gridContainer}>
            <GridItem {...styles.sideGridItemMobile}>
                <Zone zoneName="Content1" contentId={id} />
            </GridItem>
            <GridItem {...styles.mainGridItem}>
                <Zone zoneName="Content0" contentId={id} />
            </GridItem>
            <GridItem {...styles.sideGridItemDesktop}>
                <Zone zoneName="Content1" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsPageContainer,
    definition: {
        group: "Order Details",
        displayName: "Page Container",
        allowedContexts: ["OrderDetailsPage"],
    },
};

export default widgetModule;
